import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {ConfirmationModalModule} from '../../shared/confirmation-modal/confirmaton-modal.module';
import {ReportNoteModalModule} from './report-note-modal/report-note-modal.module';
import {LoginModule} from '../transact-auth/transact-auth.module';
import {RateNoteModalModule} from './rate-note-modal/rate-note-modal.module';
import {CommentModule} from './comment/comment.module';
import { SocialSharingModule } from '../social-sharing/social-sharing.module';
import { ThreadsModule } from '../threads/threads.module';
import { ContentBlurLoaderModule } from '../content-blur-loader/content-blur-loader.module';
import { AnnotationModule } from '../directives/directives.module';
import { ButtonLoaderModule } from '../button-loader/button-loader.module';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '../pipes/pipes.module';
import { ImageCaptionModule } from '../directives/image-caption.module';

import { NoteDetailedComponent } from './note-detailed.component';

import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBookmark, faExclamationTriangle, faStream, faSync, faTrashAlt, faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as faBookmarkO } from '@fortawesome/free-regular-svg-icons';
import { AudioPlayerModule } from '../audio-player/audio-player.module';
import { NoDbClickModule } from '../directives/no-db-click.module';
import { SubscriptionPlansModule } from '../subscribe-plans/subscribe-plans.module';
import { ImgLazyLoadingModule } from '../image-lazy-loading/image-lazy-loading.module';
import { DomChangedModule } from '../directives/watch-element-changes.module';
import { ImageLinksModule } from '../directives/image-links.module';
import { NotdDropdownModule } from '../notd-dropdown/notd-dropdown.module';
import { ObserveElementModule } from '../directives/observe-element.module';
import { AlertMessageModule } from '../alert-message/alert-message.module';

@NgModule({
    declarations: [ NoteDetailedComponent ],
    imports: [
        RouterModule,
        CommonModule,
        CommentModule,
        SocialSharingModule,
        ThreadsModule,
        ContentBlurLoaderModule,
        NgbRatingModule,
        FormsModule,
        ReactiveFormsModule,
        AnnotationModule,
        ButtonLoaderModule,
        ConfirmationModalModule,
        ReportNoteModalModule,
        RateNoteModalModule,
        LoginModule,
        FontAwesomeModule,
        PipesModule,
        ImageCaptionModule,
        ImageLinksModule,
        AudioPlayerModule,
        NoDbClickModule,
        SubscriptionPlansModule,
        ImgLazyLoadingModule,
        DomChangedModule,
        NotdDropdownModule,
        ObserveElementModule,
        AlertMessageModule
    ],
    exports: [ NoteDetailedComponent ]
})

export class NoteDetailedModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faSync, faTrashAlt, faExclamationTriangle, faBookmark, faBookmarkO, faVolumeUp, faStream);
  }
}
